import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInterceptor";


export const getStudents = createAsyncThunk("getStudents", async () => {

    try {
        const { data } = await axios.get('/api/coaches/me/students');
        console.log("data", data);
        return data;
    } catch (error) {
        console.error("Error fetching students:", error, axios);
        throw error;
    }
});

const getStudentsSlice = createSlice({
    name: "getStudents",
    initialState: {
        loading: false,
        students: null as any,
        error: false,
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.students = null;
            state.error = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getStudents.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getStudents.fulfilled, (state, action) => {
            state.loading = false;
            state.students = action.payload;
        });
        builder.addCase(getStudents.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    },
});
export const { reset } = getStudentsSlice.actions;
export default getStudentsSlice.reducer;
